<template>
  <q-layout>
    <LandscapeLayout v-if="isLandscape" />
    <BaseLayout v-if="isAuth && !authInProcess" :isLoading="isLoading" />
    <router-view v-else>
    </router-view>

    <q-inner-loading v-if="isLoading" :showing="isLoading">
      <AppLoader />
    </q-inner-loading>
    <q-footer class="bg-grey-3 text-primary" v-if="!isAuth">
      <q-toolbar class="base-footer">
        <div class="text-primary">Место для вашего заголовка</div>
        <q-space />
        <div class="copyright">2011-{{ new Date().getFullYear() }} © MedSafe LLC</div>
      </q-toolbar>
    </q-footer>
    <q-dialog
      v-model="modal"
      :maximized="maximized"
      :full-height="maximized"
      :full-width="maximized"
      :class="{
        'prepare-report': reportMode,
      }"
    >
      <Suspense>
        <ModalContainer @close="closeModal"> </ModalContainer>
      </Suspense>
    </q-dialog>
    <q-dialog v-model="messageShown" seamless position="bottom">
      <q-card class="row message-card bg-amber-6 text-black">
        <q-card-section class="row items-center no-wrap">
          <pre class='message-wrapper row text-center'>{{ messageContent }}</pre>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-layout>
</template>

<script setup lang="ts">
import {
  computed,
  onBeforeMount,
  onMounted,
  ref,
} from 'vue';

import ModalContainer from '~components/modals/ModalContainer.vue';
import { useMainStore } from '@/store';
import { useAuthStore } from '@/store/auth/authModule';
import { storeToRefs } from 'pinia';
import AppLoader from '~components/AppLoader.vue';
import BaseLayout from '@/layouts/BaseLayout.vue';
import { height, tabsHeaderHeight } from './constants';

const isMobileOnly = () => {
  const { userAgent, maxTouchPoints } = navigator;
  const width = Math.min(window.screen.width, window.screen.height);

  if (
    /(ipad|tablet|playbook|silk)|(android(?!.*mobile))|(windows|linux|macintosh)/i.test(userAgent)
    || (maxTouchPoints > 1 && width >= 768)
  ) return false;

  return (
    /mobi|phone|iphone|ipod|android.*mobile|blackberry|opera mini|iemobile/i.test(userAgent)
    || width < 768
  );
};

const authStore = useAuthStore();

const isLoading = ref(false);
const isLandscape = ref(false);

const { isAuth } = storeToRefs(authStore);

const authInProcess = ref(false);

onBeforeMount(async () => {
  isLoading.value = true;
  await authStore.autenticate();
  isLoading.value = false;
});

onMounted(() => {
  if (isMobileOnly()) {
    // eslint-disable-next-line no-restricted-globals
    const { orientation } = screen;
    if (orientation.angle !== 0) {
      isLandscape.value = true;
    }
    orientation.addEventListener('change', (evt: Event) => {
      console.log(orientation.angle);
      if (orientation.angle === 90 || orientation.angle === 270) isLandscape.value = true;
      else isLandscape.value = false;
    });
  }
});

const {
  modal,
  maximized,
  message,
  messageContent,
  reportMode,
} = storeToRefs(useMainStore());

const messageShown = computed(() => Boolean(message.value));

const closeModal = () => {
  useMainStore().closeModal();
};

const wrapperStyleHeight = `calc(100vh - ${height}px)`;
const tabsWrapperStyleHeight = `calc(100vh - ${height + tabsHeaderHeight}px)`;
</script>

<style lang="scss">
html.ios .q-infinite-scroll {
  -webkit-overflow-scrolling: auto !important;
}
body {
  // overflow: hidden;
}
noscript {
  display: none;
}
.prepare-report.fullscreen,
.prepare-report .fixed,
.prepare-report .fixed-full {
  position: absolute !important;
}
.copyright {
  padding: 5px 20px;
}
.q-layout {
  // height: 100vh;
  // overflow: scroll;
}
.q-footer {
  position: fixed !important;
}
.auth-banner {
  flex-direction: column;
}
.wrapper {
  display: flex;
  flex-direction: column;
  height: v-bind(wrapperStyleHeight);
}
.q-tab-panel > .wrapper {
  height: v-bind(tabsWrapperStyleHeight);
}
.container {
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-rows: auto 1fr auto;
}
.button-group {
  justify-content: space-between;
}
.fab {
  position: absolute !important;
  z-index: 10000 !important;
  &_centered {
    top: calc(50% - 28px);
    left: 50%;
    transform: translateX(-28px);
  }
  &_bottom-right {
    bottom: 28px;
    right: 28px;
  }
}
.empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}
.q-dialog__inner--minimized {
  padding: 5px !important;
}
.q-field__bottom {
  padding: 1px 12px 0px !important;
}
.base-footer {
  min-height: 30px !important;
}
.message-card .q-card__section {
  margin: 0 auto;
  height: fit-content;
}
.message-wrapper {
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
}
</style>
